import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import '../estilo/servicios.css';

export const Servicios = () => {


    return (
        <>
            {/* SECCIÓN SERVICIOS - COPIA EXACTA DEL STITCH */}
            <section className="margen1" id="services">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="text-center mb-8">
                        <h1 className="titulo1 text-center mb-[1rem]">What We Do</h1>
                        <p className=" max-w-2xl mx-auto text-lg ">Cutting-edge digital solutions tailored to scale your brand authority<br className="hidden sm:block" /> and streamline your operations.</p>
                    </div>





                    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 servicios-items">
                        <div class="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <Link to={`${process.env.REACT_APP_URL_FOLDER}/web-design-services`}>
                                <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                    <span class="material-symbols-outlined text-4xl">web</span>
                                </div>
                                <h3 >High-Converting Landing Pages</h3>
                                <p >Sleek, elite, and purposeful single-page sites designed for maximum conversion.</p>
                            </Link>
                        </div>
                        <div class="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <Link to={`${process.env.REACT_APP_URL_FOLDER}/web-design-services`}>
                                <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                    <span class="material-symbols-outlined text-4xl">shopping_cart</span>
                                </div>
                                <h3 >Online Stores</h3>
                                <p>Sell 24/7 with a robust, high-performance online store.</p>
                            </Link>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">smartphone</span>
                            </div>
                            <h3 >Custom Mobile Apps</h3>
                            <p >Put your business directly in your clients' hands with premium native apps.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">settings_suggest</span>
                            </div>
                            <h3 >Systems Automation</h3>
                            <p >Smart tech and strategic workflows. Eliminate tedious tasks, save time, and scale revenue.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center lg:col-start-2">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">campaign</span>
                            </div>
                            <h3 >Social Media Growth Campaigns</h3>
                            <p >AI-powered marketing across TikTok, Instagram, Google, YouTube, and Facebook.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">send</span>
                            </div>
                            <h3 >WhatsApp Broadcasts</h3>
                            <p >High-open-rate bulk messaging to engage your client base instantly.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">forum</span>
                            </div>
                            <h3 >AI-Powered WhatsApp Chatbots</h3>
                            <p >Automated voice and text concierge services for seamless ordering and customer care.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">videocam</span>
                            </div>
                            <h3 >Premium Video Production</h3>
                            <p >We capture your brand’s finest moments with high-end, cinematic equipment.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">movie_edit</span>
                            </div>
                            <h3 >Cinematic Video Editing</h3>
                            <p >Professional post-production to ensure your content commands attention.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">psychology</span>
                            </div>
                            <h3 >AI Human Avatars</h3>
                            <p >Striking virtual presenters that elevate your brand and scale video creation.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">3d_rotation</span>
                            </div>
                            <h3 >3D & 2D Animation & Design</h3>
                            <p >Immersive graphics and digital art that breathe life into your vision.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">ads_click</span>
                            </div>
                            <h3 >Digital Out-of-Home (DOOH) & Billboards</h3>
                            <p >Strategic local placement to dominate top-tier geographic areas.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">restaurant_menu</span>
                            </div>
                            <h3 >Dynamic Menu Displays</h3>
                            <p >High-impact visual catalogs to showcase your dishes on screen.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">school</span>
                            </div>
                            <h3 >Bespoke Tech Training</h3>
                            <p >Tailored, one-on-one executive training to master modern digital tools.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">security</span>
                            </div>
                            <h3 >Enterprise Cybersecurity</h3>
                            <p >Securing your data assets and safeguarding your business integrity.</p>
                        </div>

                    </div>






                    <div class="mt-[6rem] max-w-4xl w-full mx-auto text-center space-y-8 lg:px-6 lg:py-12 md:py-20  bg-white/50 dark:bg-transparent backdrop-blur-sm">
                        <h2 class="text-2xl md:text-6xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                            Ready to Transform <br class="hidden md:block" /> Your <span class="text-primary">Business?</span>
                        </h2>
                        <p class="max-w-2xl mx-auto text-lg md:text-xl  leading-relaxed ">
                            Leverage innovative technology to surpass your targets and scale your vision. Let’s discuss your next move.
                            <span class="block mt-4 text-xl md:text-2xl font-bold text-gray-900 dark:text-white md:whitespace-nowrap">Let’s build something exceptional together.</span>
                        </p>
                        <div class="pt-6">
                            <a class="inline-flex items-center justify-center  px-3  lg:px-10 py-4 bg-primary hover:bg-blue-700 text-white text-lg font-semibold rounded-xl transition-colors duration-300 group" href="https://api.whatsapp.com/send/?phone=5491125870303&text=&text=Hola,+quiero+iniciar+proyecto..." rel="noopener noreferrer" target="_blank">
                                <span>Start Your Project</span>
                                <span class="material-icons lg:ml-2 transition-transform duration-300 group-hover:translate-x-2">trending_flat</span>
                            </a>
                        </div>
                    </div>










                </div>
            </section >
        </>
    );
};


/**
 


<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <a href="/paginasweb" className="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">web</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Landing Pages</h3>
                            <p className="text-base font-medium dark:font-normal">Páginas simples y efectivas diseñadas para convertir.</p>
                        </a>
                        <a href="/paginasweb" className="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">shopping_cart</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Tienda Virtual</h3>
                            <p className="text-base font-medium dark:font-normal">Vende online 24/7 con una plataforma robusta y profesional.</p>
                        </a>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">smartphone</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Apps Móviles</h3>
                            <p className=" text-base font-medium dark:font-normal">Tu negocio en el celular de tus clientes con apps nativas.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">settings_suggest</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Automatización de Sistemas</h3>
                            <p className=" text-base font-medium dark:font-normal">Optimiza tu software y procesos para ahorrar tiempo.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">campaign</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Campañas en Redes Sociales</h3>
                            <p className=" text-base font-medium dark:font-normal">TikTok, Instagram, Google, YouTube, Facebook potenciados con IA.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">send</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Notificaciones WhatsApp</h3>
                            <p className=" text-base font-medium dark:font-normal">Campañas masivas a tus clientes con alta tasa de apertura.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">forum</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Chatbots de WhatsApp con IA</h3>
                            <p className=" text-base font-medium dark:font-normal">Atención y pedidos por voz y texto automatizados.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">videocam</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Filmación de Video</h3>
                            <p className=" text-base font-medium dark:font-normal">Capturamos tus mejores momentos con equipo de alta gama.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">movie_edit</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Edición de Video</h3>
                            <p className=" text-base font-medium dark:font-normal">Post-producción profesional para que tu contenido destaque.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">psychology</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Videos con IA Humana</h3>
                            <p className=" text-base font-medium dark:font-normal">Presentadores virtuales impactantes que elevan tu marca.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">3d_rotation</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Animación e Ilustración 3D y 2D</h3>
                            <p className=" text-base font-medium dark:font-normal">Gráficos con profundidad y arte digital que dan vida a tus ideas.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">ads_click</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Publicidad en Vía Pública</h3>
                            <p className=" text-base font-medium dark:font-normal">Cartelería estratégica para captar la atención local.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">restaurant_menu</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Menús Digitales</h3>
                            <p className=" text-base font-medium dark:font-normal">Precios actualizados para TV y Web en restaurantes.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">school</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Clases de Informática</h3>
                            <p className=" text-base font-medium dark:font-normal">Capacitación a medida para dominar nuevas tecnologías.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">security</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Ciberseguridad</h3>
                            <p className=" text-base font-medium dark:font-normal">Protegemos tus datos y la integridad de tu empresa.</p>
                        </div>
                    </div>

 */